import React from 'react';

import './style.css';

const NotchStub: React.FC = () => {
    return (
        <div style={{ height: '4.0rem' }} />
    );
};

interface PhoneFrameProps {
    children: React.ReactNode;
}

const fit = (element: HTMLElement) => {
    const parent = element.parentElement;
    if (!parent) {
        return;
    }

    const elementBounds = element.getBoundingClientRect();

    const scale = Math.min(
        parent.clientWidth / elementBounds.width,
        parent.clientHeight / elementBounds.height,
    );

    const prevScale = element.style.transform.match(/scale\((.*?)\)/) || [0, 1];

    element.style.transform = `scale(${scale * +prevScale[1]})`;
};

export const PhoneFrame: React.FC<PhoneFrameProps> = (props) => {
    const elementRef = React.useRef<HTMLDivElement>(null as never);

    React.useLayoutEffect(() => {
        const fitElement = () => fit(elementRef.current);
        fitElement();

        window.addEventListener('resize', fitElement);
        return () => window.removeEventListener('resize', fitElement);
    }, []);

    return (
        <div className='phone-frame__wrapper' >
            <div className='phone-frame__root' ref={elementRef}>
                <div className='phone-frame__container' >
                    <NotchStub />
                    {props.children}
                </div>
                <div className='phone-frame__frame' />
            </div>
        </div>
    );
};
